import React from "react";
import { Widget } from "smart-widget-previewer";
import { Link } from "react-router-dom";

export default function SmartWidget({ widget, onNextWidget }) {
  return (
    <div className="main-middle">
      <div
        className="box-pad-h"
        style={{
          height: "100vh",
          border: "1px solid var(--pale-gray)",
          overflow: "scroll",
        }}
      >
        <Link
          className="fit-container fx-centered fx-start-h box-pad-h-s box-pad-v-m"
          to="/"
        >
          <h3>⬅️ See all templates</h3>
        </Link>
        {widget && (
          <Widget
            event={widget}
            onNextWidget={onNextWidget}
            widgetBorderColor={"var(--pale-gray)"}
            onNostrButton={(data) =>
              window.open(`https://yakihonne.com/${data}`)
            }
            onActionWidget={(data) =>
              alert("display this url in an iframe: " + data)
            }
            onZapButton={(data) => alert("a zap action to: " + data)}
          />
        )}
      </div>
    </div>
  );
}
